import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "airport"
const AirportIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="m16.935 20.546 1.414-1.414-2.121-9.192 3.889-3.89a1.5 1.5 0 1 0-2.121-2.12l-3.89 3.888-9.192-2.12L3.5 7.11l7.425 3.89-3.89 3.889-2.474-.354-1.061 1.06 3.182 1.768 1.768 3.182 1.06-1.06-.353-2.475 3.889-3.89 3.889 7.425Z"
          />
        </svg>
      }
    </span>
  )
}
export default AirportIcon
